import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const qc = useQueryClient();

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    reload();
    const expired = () => setUser(false);
    window.addEventListener("auth:expired", expired);
    window.addEventListener("auth:pwchange", reload);
    return () => {
      window.removeEventListener("auth:expired", expired);
      window.removeEventListener("auth:pwchange", reload);
    };
  }, [reload]);

  const login = async (mobile, password) => {
    const { data } = await api.post("/auth/login", { mobile, password });
    qc.clear();
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    qc.clear();
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, logout, reload }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
